import { render, staticRenderFns } from "./users-searchbar.vue?vue&type=template&id=3dcc132c&"
import script from "./users-searchbar.vue?vue&type=script&lang=js&"
export * from "./users-searchbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports